import { z } from 'zod';
import {
  BaseElementSchema,
  ElementAppearanceSchema,
  PaintSchema,
} from '@/components/canvas/document/schema/elementBase';
import { TextContentDataSchema, TextStyleOverrideSchema } from '@/components/canvas/elements/text/schema';

export const TableCellSchema = z.object({
  text: TextContentDataSchema.optional(),
  textStyle: TextStyleOverrideSchema.partial().optional(),
  appearance: ElementAppearanceSchema.partial().optional(),
});

export const TableElementSchema = BaseElementSchema.extend({
  type: z.literal('table'),
  data: z.object({
    rows: z.number().min(1),
    cols: z.number().min(1),
    rowHeights: z.array(z.number()).optional(),
    colWidths: z.array(z.number()).optional(),
    mergedRanges: z.array(z.tuple([z.number(), z.number(), z.number(), z.number()])).optional(),
    cells: z.record(z.string(), TableCellSchema).optional(),
    borderPreset: z
      .enum(['full', 'outerOnly', 'outerInnerH', 'outerHInnerH', 'outerInnerV', 'outerVInnerV'])
      .optional(),
    tableStyle: z.enum(['default', 'bordered', 'striped']).optional(),
    rowBackgrounds: z.record(z.string(), z.array(PaintSchema)).optional(),
    colBackgrounds: z.record(z.string(), z.array(PaintSchema)).optional(),
  }),
});
